import { VHeaders } from '@/models/pagedlistmodel';

export function getLaboropCodeHeaders(vm: any): VHeaders[] {
  return [
    {
      align: 'left',
      sortable: true,
      text: vm.$parent.$t(
        'laborOpCode.laborOpCodeGridHeaders.operationCode'
      ) as string,
      value: 'operationCode',
    },
    {
      align: 'left',
      sortable: true,
      text: vm.$parent.$t(
        'laborOpCode.laborOpCodeGridHeaders.description'
      ) as string,
      value: 'description',
    },
    {
      align: 'center',
      isNotDataProp: true,
      text: vm.$parent.$t(
        'laborOpCode.laborOpCodeGridHeaders.action'
      ) as string,
      sortable: false,
    },
  ];
}
